const router = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: () => import('@/views/UserLogin.vue'),
    meta: {
      title: '登录',
      requiresAuth: false
    }
  }
  // {
  //   path: '/user/logout',
  //   name: 'UserLogout',
  //   redirect: '/user/login',
  //   meta: {
  //     title: '退出',
  //     requiresAuth: false
  //   }
  // }
];

export default router;
